






























import Vue from 'vue'
import SewipTherapists from '@/survey/measures/sewip/SewipTherapists.vue'
import { camelizeKeys } from '@/utils'

export default Vue.extend({
  components: {
    SewipTherapists,
  },
  computed: {
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  data() {
    return {
      sewip: {},
    }
  },
  props: {
    locale: {
      type: String,
    },
  },
  methods: {
    withSurvey(survey: string, data: any) {
      return {
        surveyData: {
          type: 'string',
          value: JSON.stringify(camelizeKeys(data, '_-')),
        },
        surveyType: {
          type: 'string',
          value: survey.toLowerCase(),
        },
      }
    },
  },
})
